<div class="nf-wrap">
  <div class="nf-card">
    <div class="nf-code">404</div>
    <h1 class="nf-title">Page not found</h1>
    <p class="nf-text">The page you are looking for does not exist. Check the address, or go back to the home page.</p>
    <a class="btn btn-primary nf-btn" [routerLink]="homeLink">Go to home page</a>
  </div>
</div>
